import { useState } from 'react';

export default function Services() {
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);

  const services = [
    {
      id: 1,
      title: 'Corporate Housing Solutions',
      description: 'Comprehensive temporary housing coordination for your relocating employees. We handle everything from furnished apartments to utilities setup, ensuring a smooth transition.',
      image: 'https://readdy.ai/api/search-image?query=Luxurious%20modern%20apartment%20interior%20with%20floor-to-ceiling%20windows%20overlooking%20city%20skyline%2C%20contemporary%20furnished%20living%20space%20with%20minimalist%20design%2C%20bright%20natural%20lighting%2C%20high-end%20corporate%20housing%2C%20professional%20real%20estate%20photography%2C%20clean%20white%20walls%20and%20elegant%20furniture%2C%20spacious%20open%20concept%20layout&width=800&height=600&seq=service-001&orientation=landscape',
      label: 'Housing',
      color: 'bg-lime-400'
    },
    {
      id: 2,
      title: 'Destination Services',
      description: 'Expert guidance on neighborhoods, schools, and local amenities. Our destination specialists provide personalized area tours and community integration support.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20location%20pin%20icon%20on%20deep%20navy%20blue%20background%2C%20modern%20minimalist%20design%20with%20bright%20yellow-green%20accent%20color%2C%20clean%20geometric%20shapes%2C%20corporate%20branding%20style%2C%20simple%20and%20elegant%20business%20graphics%2C%20high%20contrast%20professional%20illustration&width=600&height=600&seq=service-002&orientation=squarish',
      label: 'Guidance',
      color: 'bg-yellow-400'
    },
    {
      id: 3,
      title: 'Relocation Management',
      description: 'End-to-end relocation project management with dedicated coordinators. We streamline the entire process from planning to settlement.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20handshake%20in%20modern%20corporate%20office%20setting%2C%20two%20business%20professionals%20shaking%20hands%2C%20bright%20natural%20lighting%2C%20clean%20contemporary%20office%20interior%2C%20trust%20and%20partnership%20concept%2C%20professional%20corporate%20photography%2C%20warm%20and%20welcoming%20atmosphere&width=600&height=600&seq=service-003&orientation=squarish',
      label: 'Management',
      color: 'bg-orange-400'
    }
  ];

  return (
    <section id="services" className="py-24 px-8 md:px-16 lg:px-24 bg-stone-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
            Your Relocation Journey 🏠
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive services designed to make corporate relocations effortless
          </p>
        </div>

        {/* Service Cards */}
        <div className="flex flex-col lg:flex-row gap-6">
          {services.map((service, index) => (
            <div
              key={service.id}
              className={`relative overflow-hidden rounded-3xl cursor-pointer transition-all duration-500 ${
                hoveredCard === index
                  ? 'lg:flex-[1.3]'
                  : hoveredCard !== null
                  ? 'lg:flex-[0.85]'
                  : index === 0
                  ? 'lg:flex-[1.35]'
                  : index === 1
                  ? 'lg:flex-[1]'
                  : 'lg:flex-[0.85]'
              }`}
              style={{ minHeight: '500px' }}
              onMouseEnter={() => setHoveredCard(index)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              {/* Background Image */}
              <img
                src={service.image}
                alt={service.title}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />

              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/60 to-transparent opacity-80"></div>

              {/* Content */}
              <div className="relative h-full flex flex-col justify-end p-8">
                {/* Label */}
                <div className={`${service.color} text-gray-900 px-4 py-2 rounded-full text-sm font-semibold inline-flex items-center w-fit mb-4 whitespace-nowrap`}>
                  {service.label}
                </div>

                {/* Title */}
                <h3 className="text-white text-3xl font-bold mb-3">
                  {service.title}
                </h3>

                {/* Description */}
                <p className="text-white/90 text-base leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
